import { isEmpty } from "lodash";
import { $Q, $Qll } from "../utils/query-selector";

/**
 * change the variables of the inputs
 */

export function chageStepForm() {
  const inputChecket = $Qll('.variant__input:checked');
  const variantsadvice = `${inputChecket[0]?.value} / ${inputChecket[1]?.value}`;
  const messageObject = $Q('.funnel-form-js');
  const imageVariant = $Q('.swiper-slide-active').innerHTML;
  const imageObject = $Q('.funnel-form__img');

  if (messageObject) messageObject.innerHTML = variantsadvice;
  if (imageObject) imageObject.innerHTML = imageVariant;
}

/**
 * validate the email elements in the local storage
 */

export function enableLocalStorage() {
  const email = localStorage.getItem('email');

  if (email) {
    const emailInput = $Q('[name="customerEmail"]')
    if (isEmpty(emailInput?.value) && emailInput) {
      emailInput.value = email;
    }
  }
}

/**
 * active or inactive the button
 * @param {text} node - class of the buttons
 * @param {bool} active - able or disable the button
 */

function activeBtn(node, active = true) {
  const button = $Q(node);

  if (active) {
    button.disabled = false;
  } else {
    button.disabled = true;
  }
}

/**
 * Copy the fields modify the node
 * @param {node} node - fields baby inputs
 */

function modifyNode(node) {
  const copyNode = node
  const newIndex = parseInt(copyNode.dataset.index, 10) + 1
  copyNode.dataset.index = `${newIndex}`;

  $Qll('.funnel-form__label', copyNode).forEach((element) => {
    $Q('.funnel-form__input', element).value = '';
    const label = $Q('.form-description-js', element);
    const newLabel = label.innerHTML.replace(/[0-9]/g, `${newIndex}`);

    label.innerHTML = newLabel;
  });

  if (newIndex === 6) {
    activeBtn('.butto-add-form-js', false);
  }

  return copyNode
}

/**
 * Add a baby name fields, if exist 6 fields block de button add
 */

export function addFields() {
  const buttonAdd = $Q('.butto-add-form-js');

  buttonAdd?.addEventListener('click', () => {
    const parentObject = $Q('.js-funnel-form');
    const nodeObject = parentObject.lastElementChild;

    if (nodeObject.dataset.index <= 5) {
      const copyNode = modifyNode(nodeObject.cloneNode(true));
      parentObject.appendChild(copyNode);

      activeBtn('.butto-remove-form-js');
    } else {
      activeBtn('.butto-add-form-js', false);
    }
  })
}

/**
 * Removes the last child of the parent element in this case,
 * as there is only 1 child left, the button is locked.
 */

export function removeFields() {
  const buttonAdd = $Q('.butto-remove-form-js');

  buttonAdd?.addEventListener('click', () => {
    const parentObject = $Q('.js-funnel-form');
    const nodeObject = parentObject.lastElementChild;

    if (nodeObject.dataset.index >= 2) {
      nodeObject.remove();

      activeBtn('.butto-add-form-js');
    } else {
      activeBtn('.butto-remove-form-js', false);
    }
  })
}

/**
 * Removes the last child of the parent element in this case,
 * as there is only 1 child left, the button is locked.
 */

export function validateInputs() {
  const inputs = $Qll('.form-input-js');
  let field = false;

    inputs.forEach((element) => {
      if (!isEmpty(element.value)) {
        field = true;
      }
    });

  return field;
}

/**
 * Construc the cilds, in 2 fields name and date
 * if the date not exist no fill the field
 */

function childInputs() {
  const child = $Qll('.form-date-js');
  const arrayInput = [];

  child.forEach((element) => {
    const name = $Q('#name', element).value;
    const date = $Q('#birthday', element).value;

    if (!date) {
      arrayInput.push({
        babyName: name || '-',
      })
    } else if (date) {
      arrayInput.push({
        babyName: name || '-',
        babyBirthdate: date,
      })
    }
  });

  return arrayInput;
}

/**
 * Send data for the backend form
 * @param {object} data - all fields necesary in the object
 */

export function sendData(data) {
  const link = window.formLink || $Q('[name="customerEmail"]')?.value;

  if (link) {
    fetch(`${link}`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: {
      "Content-type": 'application/json',
    },
  }).then((res) => res.json())
    .then((json) => console.log(json))
  }
}

/**
 * Save in the session storage the object of the form
 * @param {object} data - all fields necesary in the object
 */

function saveSessionStorage(data) {

  if (data) {
    if (data.email) {
      sendData(data);
    } else {
      const objectData = JSON.stringify(data);

      sessionStorage.setItem("formData", objectData);
    }
  }
}

/**
 * construct the data object form
 */

function constructData() {
  const inputs = validateInputs();

  if (inputs) {
    const parent = $Q('#parent-name').value || $Q('#mother-name').value
    const splitParent = parent.split(' ');

    const formData = {
        email: $Q('[name="customerEmail"]')?.value || null,
        parentLastName: splitParent[0],
        parentName: splitParent[1] || '-',
        childs: childInputs(),
    }

    saveSessionStorage(formData);
  }
}

/**
 * Read the button change of the step 2 action
 */

export function sendInformation() {
  const button = $Q('.form-btn-js');

  button?.addEventListener('click', () => constructData())
}
